import axios from 'axios'

import { APP_BASE_PATH } from '@/constants/site'

/** Axios client scoped to the Next.js basePath (`/create`). */
const apiClient = axios.create({
  baseURL: APP_BASE_PATH,
})

export default apiClient
